import React from "react";
import { motion } from "framer-motion";
const DEFAULT_STATS = [
  { number: "100%", label: "מחיר עלות מקורי" },
  { number: "30+", label: "מדינות בעולם" },
  { number: "500+", label: "אירועים בשנה" },
  { number: "5,000+", label: "חברי קהילה" },
];

export default function StatsSection({ config }) {
  const stats = config?.items ?? DEFAULT_STATS;
  return (
    <section
      dir="rtl"
      style={{
        backgroundImage: "url('https://media.base44.com/images/public/69b41710d6b60acb7a810a52/14d47f2eb_stats_bg.png')",
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
        backgroundColor: "#252525",
        padding: "48px 16px",
      }}
    >
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-4 gap-0"
        >
          {stats.map(({ number, label }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="flex flex-col items-center text-center px-4 py-4"
            >
              <p
                className="font-black leading-none"
                style={{ fontSize: "clamp(2rem, 4vw, 3rem)", color: "#C8F135" }}
              >
                {number}
              </p>
              <p className="text-xs font-bold mt-2" style={{ color: "rgba(255,255,255,0.75)" }}>{label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}